import { render, staticRenderFns } from "./StepSkyldner.vue?vue&type=template&id=cb395c8e&scoped=true&"
import script from "./StepSkyldner.vue?vue&type=script&lang=js&"
export * from "./StepSkyldner.vue?vue&type=script&lang=js&"
import style0 from "./StepSkyldner.vue?vue&type=style&index=0&id=cb395c8e&lang=scss&scoped=true&"
import style1 from "./StepSkyldner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb395c8e",
  null
  
)

export default component.exports